import { render } from "./VideosSection.vue?vue&type=template&id=fa1af4b4&scoped=true"
import script from "./VideosSection.vue?vue&type=script&lang=js"
export * from "./VideosSection.vue?vue&type=script&lang=js"

import "./VideosSection.vue?vue&type=style&index=0&id=fa1af4b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fa1af4b4"

export default script